import type { FeatureContext, FeatureFlagDefinition, FeatureFlagPort } from '@ochal/module-sdk/contracts';

export interface FeatureFlagProvider { load(signal?: AbortSignal): Promise<readonly FeatureFlagDefinition[]> }
export class FeatureFlagRuntime implements FeatureFlagPort {
  private readonly flags = new Map<string, FeatureFlagDefinition>();
  constructor(flags: readonly FeatureFlagDefinition[] = []) { this.replace(flags); }
  replace(flags: readonly FeatureFlagDefinition[]): void { const next = new Map<string, FeatureFlagDefinition>(); for (const flag of flags) { if (!/^[a-z][a-z0-9.-]+$/.test(flag.id)) throw new Error(`Invalid feature flag: ${flag.id}`); if (next.has(flag.id)) throw new Error(`Duplicate feature flag: ${flag.id}`); next.set(flag.id, Object.freeze({ ...flag })); } this.flags.clear(); for (const [id, flag] of next) this.flags.set(id, flag); }
  async refresh(provider: FeatureFlagProvider, signal?: AbortSignal): Promise<void> { this.replace(await provider.load(signal)); }
  isEnabled(id: string | undefined, context: FeatureContext = {}): boolean {
    if (!id) return true;
    const flag = this.flags.get(id);
    if (!flag || flag.state === 'disabled') return false;
    if (flag.expiresAt && Date.parse(flag.expiresAt) <= Date.now()) return false;
    return !flag.allowedRoles?.length || flag.allowedRoles.some((role) => context.roles?.includes(role));
  }
  snapshot(): readonly FeatureFlagDefinition[] { return [...this.flags.values()]; }
}
